;(function () {
  'use strict'

  angular
    .module('contrast.scan-projects')
    .controller('ScanProjectsCtrl', [ScanProjectsCtrl])
  function ScanProjectsCtrl($scope) {
    function _setDefaults() {
      $scope.model = {
        title: formatMessage({ id: 'title_scanProjects' }),
        description: ''
      }
    }

    function init() {
      _setDefaults()
    }

    init()
  }
})()
